module.exports = __webpack_public_path__ + "img/markerOriginLight.7c285dd2.svg";